"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConversationIsEmpty = exports.getConversationTranscript = exports.getConversationTextHistory = exports.getConversationUtteranceAtIndexText = exports.getConversationUtterances = exports.getConversationLastItemIndex = exports.getConversationLastItem = exports.getConversationQueue = exports.getConversationProcessing = exports.getConversation = void 0;

var _constants = require("../../constants");

var getConversation = function getConversation(state) {
  return state.conversation.base;
};

exports.getConversation = getConversation;

var getConversationProcessing = function getConversationProcessing(state) {
  return state.conversation.processing;
};

exports.getConversationProcessing = getConversationProcessing;

var getConversationQueue = function getConversationQueue(state) {
  return state.conversation.queue;
};

exports.getConversationQueue = getConversationQueue;

var getConversationLastItem = function getConversationLastItem(state) {
  var conversation = getConversation(state);
  return conversation[conversation.length - 1];
};

exports.getConversationLastItem = getConversationLastItem;

var getConversationLastItemIndex = function getConversationLastItemIndex(state) {
  return getConversation(state).length - 1;
};

exports.getConversationLastItemIndex = getConversationLastItemIndex;

var getConversationUtterances = function getConversationUtterances(state) {
  return getConversation(state).filter(function (message) {
    return message.type === _constants.CONVERSATION_TYPE_UTTERANCE;
  }).sort(function (a, b) {
    return b.index - a.index;
  });
};

exports.getConversationUtterances = getConversationUtterances;

var getConversationUtteranceAtIndexText = function getConversationUtteranceAtIndexText(state, index) {
  var conversationUtterances = getConversationUtterances(state);
  var conversationUtteranceAtIndex = conversationUtterances[index];

  if (conversationUtteranceAtIndex && conversationUtteranceAtIndex.items && conversationUtteranceAtIndex.items[0]) {
    return conversationUtteranceAtIndex.items[0];
  }

  return null;
};

exports.getConversationUtteranceAtIndexText = getConversationUtteranceAtIndexText;

var getConversationTextHistory = function getConversationTextHistory(state) {
  return getConversation(state).filter(function (message) {
    return message.type === _constants.CONVERSATION_TYPE_UTTERANCE || message.type === _constants.CONVERSATION_TYPE_TEXT_BOT;
  }).map(function (message) {
    var preFix = message.type === _constants.CONVERSATION_TYPE_UTTERANCE ? 'user: ' : 'bot: ';
    return preFix + message.items[0];
  });
};

exports.getConversationTextHistory = getConversationTextHistory;

var getConversationTranscript = function getConversationTranscript(state) {
  var conversation = getConversation(state);
  var formattedTranscript = "***** Please review the conversation that occurred between the customer and our help bot *****\n".concat(conversation.filter(function (message) {
    return [_constants.CONVERSATION_TYPE_TEXT_BOT, _constants.CONVERSATION_TYPE_UTTERANCE].includes(message.type);
  }).map(function (message) {
    var type = message.type === _constants.CONVERSATION_TYPE_UTTERANCE ? 'Customer' : 'Bot';
    return "".concat(type, ": ").concat(message.items.join('\n'));
  }).join('\n'), "\n***** The conversation ends here *****");
  return formattedTranscript;
};

exports.getConversationTranscript = getConversationTranscript;

var getConversationIsEmpty = function getConversationIsEmpty(state) {
  return getConversation(state).length <= 1;
};

exports.getConversationIsEmpty = getConversationIsEmpty;